import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import { kickoffKey, kickoffVisible } from "@/lib/seasonKickoff";

// Round H — één aankondiging per seizoen op het opnemen-scherm. Iedereen met de rol
// gebruiker of beheerder doet automatisch mee; dit is puur de aftrap.
export const SeasonKickoff = ({ data, user }) => {
  const season = data?.season;
  const [dismissed, setDismissed] = useState(null);
  useEffect(() => {
    if (!user?.id || !season?.id) return;
    try {
      setDismissed(localStorage.getItem(kickoffKey(user.id, season.id)) ? season.id : null);
    } catch {
      setDismissed(null);
    }
  }, [user?.id, season?.id]);
  if (!kickoffVisible(data, user, dismissed)) return null;
  const close = () => {
    try { localStorage.setItem(kickoffKey(user.id, season.id), "1"); } catch { /* noop */ }
    setDismissed(season.id);
  };
  return (
    <section
      className="bg-tw-yellow/5 border-l-4 border-tw-yellow border-y border-r border-tw p-4 sm:p-5 mb-6 tw-fadeup"
      role="status"
      data-testid="season-kickoff"
    >
      <div className="flex items-start gap-3">
        <Megaphone size={16} className="text-tw-yellow shrink-0 mt-0.5" strokeWidth={2.5} aria-hidden />
        <div className="flex-1 min-w-0">
          <div className="font-mono text-[10px] tracking-[0.3em] text-tw-yellow uppercase mb-1">
            Nieuw seizoen
          </div>
          <p className="text-[15px] text-white font-display font-bold break-words" data-testid="season-kickoff-name">
            {season.name}
          </p>
          <p className="text-sm text-tw-yellow mt-1 break-words" data-testid="season-kickoff-focus">
            {season.focus_category} telt deze week dubbel.
          </p>
          {season.kickoff_message && (
            <p className="text-sm text-white mt-2 break-words" data-testid="season-kickoff-message">
              {season.kickoff_message}
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={close}
          data-testid="season-kickoff-dismiss"
          aria-label="Bericht sluiten"
          className="text-tw-muted hover:text-white transition-colors shrink-0 p-1 font-mono text-[10px] uppercase tracking-[0.2em] flex items-center gap-1"
        >
          Sluiten <X size={14} strokeWidth={2.5} />
        </button>
      </div>
    </section>
  );
};
